import React, { useState, useEffect, useContext } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Input,
  Button,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import DataTable from "react-data-table-component";
import { useDispatch, useSelector } from "react-redux";
import { ThemeContext } from "../contexts/ThemeContext.js";
import { fetchNegotiations, deleteNegotiationAttempt } from "../redux/actions/negotiationActions.js";

const NegotiateList = () => {
  const { theme } = useContext(ThemeContext);
  const dispatch = useDispatch();

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedNegotiation, setSelectedNegotiation] = useState([]);
  const [selectedNegotiationId, setSelectedNegotiationId] = useState(null);

  const { negotiations = [], loading } = useSelector((state) => state.negotiationList);

  const handleDeleteAttempt = async (negotiationId, attemptIndex) => {
    if (window.confirm("Are you sure you want to delete this negotiation attempt?")) {
      try {
        await dispatch(deleteNegotiationAttempt(negotiationId, attemptIndex));
        triggerGetList();
        alert("Negotiation attempt deleted successfully.");
        setModalOpen(false);
      } catch (error) {
        alert(error.message);
      }
    }
  };

  const columns = [
    {
      name: <b>S.No</b>,
      cell: (row, index) => index + 1 + (currentPage - 1) * itemsPerPage,
    },
    { name: <b>Voucher ID</b>, selector: (row) => row?.voucher?.voucherId },
    { name: <b>Buyer Name</b>, selector: (row) => row?.buyer?.name },
    { name: <b>Seller Name</b>, selector: (row) => row?.seller?.name },
    {
      name: <b>Actual Price</b>,
      selector: (row) => `Rs.${row?.voucher?.actualPrice}`,
    },
    {
      name: <b>Selling Price</b>,
      selector: (row) => `Rs.${row?.voucher?.sellingPrice}`,
    },
    {
      name: <b>Negotiated Price</b>,
      selector: (row) =>
        row?.adminApprovedPrice != null ? `Rs.${row?.adminApprovedPrice}` : "",
    },
    {
      name: <b>Negotiation Attempts</b>,
      cell: (row) => (
        <Button
          color="info"
          size="sm"
          onClick={() => {
            setSelectedNegotiation(row?.negotiationAttempts || []);
            setSelectedNegotiationId(row?.negotiationId);
            setModalOpen(true);
          }}
        >
          View
        </Button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  const triggerGetList = () => {
    dispatch(fetchNegotiations(currentPage, itemsPerPage, searchTerm));
  };

  useEffect(() => {
    triggerGetList();
  }, [currentPage, itemsPerPage, searchTerm]);

  return (
    <Container fluid>
      <Row className="mb-3">
        <Col sm="6">
          <h4>Negotiation List</h4>
        </Col>
        <Col sm="6" className="text-right">
          <Input
            type="text"
            placeholder="Search by Buyer / Seller / Voucher ID"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </Col>
      </Row>

      <Card>
        <CardBody>
          <DataTable
            pagination
            columns={columns}
            data={negotiations}
            theme={theme === "dark" ? "darkMode" : "lightMode"}
            paginationServer
            paginationTotalRows={negotiations.length}
            paginationPerPage={itemsPerPage}
            onChangePage={(page) => setCurrentPage(page)}
            onChangeRowsPerPage={(newPerPage, page) => {
              setItemsPerPage(newPerPage);
              setCurrentPage(page);
            }}
            progressPending={loading}
          />
        </CardBody>
      </Card>

      <Modal isOpen={modalOpen} toggle={() => setModalOpen(!modalOpen)} size="lg">
        <ModalHeader toggle={() => setModalOpen(!modalOpen)}>Negotiation Attempts</ModalHeader>
        <ModalBody>
          <Table bordered>
            <thead>
              <tr>
                <th>#</th>
                <th>Proposed Price</th>
                <th>Status</th>
                <th>Created At</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {selectedNegotiation.map((attempt, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>Rs.{attempt?.proposed_price}</td>
                  <td>{attempt?.attempt_status}</td>
                  <td>{new Date(attempt?.created_at).toLocaleDateString("en-GB")}</td>
                  <td>
                    <Button
                      color="danger"
                      size="sm"
                      onClick={() => handleDeleteAttempt(selectedNegotiationId, index)}
                    >
                      Delete
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </ModalBody>
      </Modal>
    </Container>
  );
};

export default NegotiateList;
